import { createSlice } from "@reduxjs/toolkit";
import { getExpertLessonRevenueHistory } from "redux/actions/expertRevenueManagment";

export interface IRevenueHistoryItem {
  id: number
  date: string
  lessonName: string
  revenueHistoryItemStudentList: IRevenueHistoryItemStudentList[]
}

export interface IRevenueHistoryItemStudentList {
  avatar:string,
  userName:string,
  points:number
}

export interface IRevenue {
  totalPoints: number | null
  startDate: string | null
  endDate: string | null
  lessonHistory: IRevenueHistoryItem[]
  loading: boolean
}

const initialState: IRevenue = {
  totalPoints: null,
  startDate: null,
  endDate: null,
  lessonHistory: [],
  loading: false
};

export const revenueManagementSlice = createSlice({
  name: "revenueManagementSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExpertLessonRevenueHistory.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getExpertLessonRevenueHistory.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(
      getExpertLessonRevenueHistory.fulfilled,
      (state, action) => {
        state.totalPoints = action.payload.totalPoints;
        state.lessonHistory = action.payload.lessonHistory;
        state.startDate = action.payload.startDate;
        state.endDate =  action.payload.endDate;
        state.loading = false;
      }
    );
  }
});

export default revenueManagementSlice.reducer;
